import React from 'react';

import { useDynamicIcon } from '@lumapps/assets/hooks/useDynamicIcon';
import { enabledFeaturesSelector } from '@lumapps/features';
import { Badge, Icon } from '@lumapps/lumx/react';
import { useSelector } from '@lumapps/redux/react';
import { UserAvatar } from '@lumapps/user-ui/components/UserAvatar';
import { User } from '@lumapps/user/types';

import { getNotificationMeta } from '../../notification-meta';
import { Notification } from '../../types';

export type NotificationListItemBeforeProps = {
    className?: string;
    // The notification
    notification: Notification;
    // Details about the sender
    senderDetails?: User | null;
};

export const NotificationListItemBefore: React.FC<NotificationListItemBeforeProps> = ({
    className,
    notification,
    senderDetails,
}) => {
    const enabledFeatures = useSelector(enabledFeaturesSelector);

    const { type } = notification;
    const {
        hasThumbnail = false,
        iconProps: defaultIconProps,
        getIconProps,
        hasBadge = hasThumbnail,
    } = getNotificationMeta(type);
    const iconProps = getIconProps ? getIconProps({ enabledFeatures, iconProps: defaultIconProps }) : defaultIconProps;
    const { iconPath: iconDynamicPath } = useDynamicIcon({ icon: iconProps.icon });
    const iconPath = iconProps.customIcon || iconDynamicPath;

    if (hasThumbnail && senderDetails) {
        return (
            <UserAvatar
                user={senderDetails}
                useAvatarFromApiProfile
                badge={
                    hasBadge ? (
                        <Badge color={iconProps.color}>
                            <Icon icon={iconPath} />
                        </Badge>
                    ) : undefined
                }
            />
        );
    }

    return (
        <Icon
            className={className}
            icon={iconPath}
            color={iconProps.color}
            colorVariant={iconProps.colorVariant}
            hasShape
        />
    );
};
